// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3n9cj","itemTitle":"ClientEmergencyInfo_itemTitle__16tMd","itemText":"ClientEmergencyInfo_itemText__yVc75"};